/* =================================================================

  アコーディオン

================================================================= */

export const accordion = function () {
  const slideUp = (el, duration = 300) => {
    el.style.height = el.offsetHeight + "px";
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    setTimeout(() => {
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("padding-top");
      el.style.removeProperty("padding-bottom");
      el.style.removeProperty("margin-top");
      el.style.removeProperty("margin-bottom");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
      el.classList.remove("is-open");
    }, duration);
  };

  const slideDown = (el, duration = 300) => {
    el.classList.add("is-open");
    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") display = "block";
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.height = height + "px";
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    setTimeout(() => {
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
    }, duration);
  };

  const slideToggle = (el, duration = 300) => {
    if (window.getComputedStyle(el).display === "none") {
      return slideDown(el, duration);
    } else {
      return slideUp(el, duration);
    }
  };

  const setupAccordion = (selector, onlySP = false) => {
    const accordions = document.querySelectorAll(selector);

    accordions.forEach((accordion) => {
      const triggers = accordion.querySelectorAll(".js-accordion-trigger");
      triggers.forEach((trigger) => {
        const target = trigger.nextElementSibling;
        const container = trigger.closest(selector);

        const toggleAccordion = () => {
          if (onlySP && window.innerWidth > 744) return;

          trigger.classList.toggle("is-active");
          const isHidden = target.style.display === "none" || window.getComputedStyle(target).display === "none";

          if (isHidden) {
            container?.classList.add("is-active");
          } else {
            container?.classList.remove("is-active");
          }

          slideToggle(target);
        };

        trigger.addEventListener("click", toggleAccordion);
      });

      const closeBtns = accordion.querySelectorAll(".js-accordion-close");
      closeBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const trigger = accordion.querySelector(".js-accordion-trigger");
          const target = accordion.querySelector(".js-accordion-target");

          if (onlySP && window.innerWidth > 744) return;

          trigger.classList.toggle("is-active");
          accordion.classList.toggle("is-active");
          slideToggle(target);
        });
      });
    });
  };

  // 通常アコーディオン
  setupAccordion(".js-accordion");

  // スマホ限定アコーディオン
  setupAccordion(".js-accordion--sp", true);

  /* ===================================================
     SP→PC切り替え時のリセット
  =================================================== */
  const resetSPAccordion = () => {
    const spAccordions = document.querySelectorAll(".js-accordion--sp");
    spAccordions.forEach((acc) => {
      const target = acc.querySelector(".js-accordion-target");
      if (!target) return;

      if (window.innerWidth > 744) {
        // PCサイズ時は強制的に表示（閉じていても開く）
        target.style.display = "block";
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
      } else {
        // SP時：is-activeがない場合は非表示
        if (acc.classList.contains("is-active")) {
          target.style.display = "block";
        } else {
          target.style.display = "none";
        }
      }
    });
  };

  window.addEventListener("resize", resetSPAccordion);
  resetSPAccordion();
};
